import React from "react";
import Filter from '../../../components/CRM/Filter';
import TextInput from "../../../components/CRM/TextInput";
import NullableBooleanInput from "../../../components/CRM/NullableBooleanInput";
import DateInput from "../../../components/CRM/DateInput";

const GameTipFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.gametips.search" source="title_like" />

    <TextInput label="resources.gametips.inputs.author" source="author_like" />

    <DateInput label="resources.gametips.inputs.date" source="date" />

    <NullableBooleanInput
      label="resources.gametips.fields.published"
      source="published"
      defaultValue={true}
    />
  </Filter>
);

export default GameTipFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/GameTipFilter.js